import { Box, Button, Heading, HStack, Input, InputGroup, InputLeftElement, Spinner, Text, VStack } from "@chakra-ui/react";
import { HiOutlinePlus, HiOutlineSearch } from "react-icons/hi";
import { groupLists } from "./codexUtils";

/** The code lists, searchable and grouped by data standard. */
const CodeListSidebar = ({ lists, loading, search, onSearch, selectedId, onSelect, onNew }) => {
  const groups = groupLists(lists, search);
  return (
    <VStack align="stretch" spacing={3} borderWidth="1px" borderRadius="md" bg="whiteAlpha.800" p={3} h="100%" minH={0}>
      <HStack justify="space-between">
        <Heading size="sm">Code lists</Heading>
        <Button size="xs" leftIcon={<HiOutlinePlus />} colorScheme="blue" onClick={onNew}>New</Button>
      </HStack>
      <InputGroup size="sm">
        <InputLeftElement pointerEvents="none"><HiOutlineSearch color="gray" /></InputLeftElement>
        <Input placeholder="Search ID, name or standard…" value={search} onChange={(e) => onSearch(e.target.value)} bg="white" />
      </InputGroup>
      <Box overflowY="auto" flex="1" minH={0} mx={-1} px={1}>
        {loading ? (
          <Spinner size="sm" />
        ) : groups.length === 0 ? (
          <Text fontSize="sm" color="gray.500">No code lists match.</Text>
        ) : (
          groups.map((g) => (
            <Box key={g.standard} mb={3}>
              <Text fontSize="2xs" textTransform="uppercase" letterSpacing="wide" color="gray.500" mb={1}>
                {g.standard} · {g.lists.length}
              </Text>
              {g.lists.map((l) => {
                const isSelected = l.tableID === selectedId;
                return (
                  <Box
                    key={l._id || l.tableID}
                    as="button"
                    type="button"
                    w="100%"
                    textAlign="left"
                    px={2}
                    py={1.5}
                    borderRadius="md"
                    bg={isSelected ? "blue.600" : "transparent"}
                    color={isSelected ? "white" : undefined}
                    _hover={{ bg: isSelected ? "blue.600" : "blackAlpha.50" }}
                    onClick={() => onSelect(l.tableID)}
                    aria-current={isSelected ? "true" : undefined}>
                    <HStack spacing={2} align="baseline">
                      <Text fontFamily="mono" fontSize="sm" fontWeight="semibold" flexShrink={0}>{l.tableID}</Text>
                      <Text fontSize="sm" noOfLines={1} color={isSelected ? "whiteAlpha.900" : "gray.700"}>{l.name}</Text>
                    </HStack>
                  </Box>
                );
              })}
            </Box>
          ))
        )}
      </Box>
      <Text fontSize="xs" color="gray.500">{(lists || []).length} code lists</Text>
    </VStack>
  );
};

export default CodeListSidebar;
